import React, {useEffect, useState} from "react";
import {Button, Card, Col, Empty, Input, Row, Spin} from "antd";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import "./UniformGatePage.less";
import iconfont from "../../assets/font/appfonts/iconfont.json";

const {Meta} = Card;

const iconBgColors = ["flowfont-blue", "flowfont-green", "flowfont-yellow", "flowfont-red"];
const defaultIcons = ["default_icon_blue", "default_icon_green", "default_icon_yellow", "default_icon_red"];

const UniformGatePage = (props) => {
  const [applications, setApplications] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getApplications();
  }, []);

  const getApplications = () => {
    setLoading(true);
    ApplicationBackend.getUserAppDetails(props.account.owner, props.account.id, keyword)
      .then((res) => {
        setLoading(false);
        setApplications((res.msg === undefined) ? res : []);
      });
  };

  const getItems = () => {
    const items = [];
    applications.forEach(application => {
      items.push({
        link: application.homepageUrl, name: application.displayName, desc: application.description,
        logo: application.logo, systemLogo: application.systemLogo, sysLogoBg: application.sysLogoBg,
      });
    });

    return items;
  };

  const wrappedAsSilentSigninLink = (link) => {
    if (link.startsWith("http")) {
      link += link.includes("?") ? "&silentSignin=1" : "?silentSignin=1";
    }
    return link;
  };

  const renderCard = (item, index) => {
    const silentSigninLink = wrappedAsSilentSigninLink(item.link);

    return (
      <Col style={{marginBottom: "20px", height: 94}} span={6}>
        <Card
          hoverable
          className={`uniform-card uniform-card-${index % 4}`}
          onClick={() => Setting.goToLinkSoft({props: props}, silentSigninLink)}
        >
          <Row type="flex" align="middle" style={{height: "100%"}}>
            <Col style={{marginLeft: 15, marginRight: 15}}>
              {
                item.systemLogo === "" ?
                  item.logo === "" ?
                    <li className={["app-icon", `${iconBgColors[index % 4]}`].join(" ")} style={{width: 56, height: 56}}
                    >
                      <img alt="logo" src={require(`../../assets/images/${defaultIcons[index % 4]}.png`)} style={{height: 30, objectFit: "scale-down"}} />
                    </li>
                    :
                    <li className={["app-icon", `${iconBgColors[index % 4]}`].join(" ")} style={{width: 56, height: 56}}
                    >
                      <img src={item.logo} width={56} height={56} style={{objectFit: "cover", borderRadius: "50%"}}
                        onError={(e) => {
                          // e.target.src = require(`../../assets/images/${defaultIcons[index % 4]}.png`);
                        }}
                      />
                    </li>
                  :
                  <li className="icon-container" style={{width: 56, height: 56}}
                  >
                    <span className={["app-icon", `${iconfont.font_family} ${iconfont.css_prefix_text}${item.systemLogo}`, iconBgColors[index % 4]].join(" ")}
                      style={{width: 56, height: 56, fontSize: 30}}></span>
                  </li>
              }
            </Col>
            <Meta title={item.name} description={
              <div style={{wordBreak: "break-all"}}>
                {item.desc}
              </div>
            }
            />
          </Row>
        </Card>
      </Col>
    );
  };

  const renderCards = () => {
    if (applications === null) {
      return null;
    }

    const items = getItems();
    const appBg = {
      width: "100%",
      height: "100%",
      background: `url(${
        require("../../assets/images/apps_bg.png")
      }) center top no-repeat`,
      backgroundSize: "100% 100%",
      padding: "20px  30px",
    };
    if (Setting.isMobile()) {
      return (
        <Card className="content-warp-card">
          <Card bodyStyle={{padding: 0}}>
            {
              items.map(item => {
                if (item.link) {
                  return (
                    <div key={item.link} logo={item.logo} link={item.link} title={item.name} desc={item.description} isSingle={items.length === 1} />
                  );
                }
              })
            }
          </Card>
        </Card>
      );
    } else {
      return (
        <div style={appBg}>
          <Row type="flex" justify="center" style={{marginTop: "80px"}}>
            <Col span={8}>
              <Input
                allowClear
                placeholder={i18next.t("application:Please input application name")}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onPressEnter={e => getApplications()}
                suffix={
                  <Button style={{backgroundColor: "#2d78d5", color: "#fff"}} onClick={() => getApplications()}>{i18next.t("general:Search")}</Button>
                }
              />
            </Col>
          </Row>
          {
            loading ?
              <Row type="flex" justify="center" className="example" style={{marginTop: "50px"}}>
                <Spin />
              </Row>
              :
              <>
                {
                  items.length > 0 ?
                    <div style={{background: "#fff", marginLeft: "15%", marginRight: "15%", marginTop: "40px", padding: "30px 30px", height: "calc(100% - 240px)", borderRadius: "6px", overflow: "auto"}}>
                      <Row type="flex" align="flex-start" style={{background: "#fff"}} gutter={24}>
                        {
                          items.map((item, index) => {
                            return (
                              renderCard(item, index)
                            );
                          })
                        }
                      </Row>
                    </div>

                    :
                    <Empty style={{marginTop: "50px"}} />
                }
              </>
          }
        </div>
      );
    }
  };

  return <>
    {renderCards()}
  </>;
};

export default UniformGatePage;
